<nk-help-popover class="ms-2" [popoverTemplate]="fraudRiskScoreHelpInfo"></nk-help-popover>

<ng-template #fraudRiskScoreHelpInfo>
  <div class="small" style="max-width: 450px">
    <p>
      {{ 'fraud_risk_score.help_info' | translate }}
    </p>
    <ul class="list-unstyled mb-0">
      @for (item of fraudRiskScoreRanges; track item.level) {
        <li class="d-flex align-items-center mb-1">
          <i class="fa fa-circle me-2 colorize risk {{ item.level }}"></i>
          <span>{{ fraudRiskScoreTranslations[item.level] | translate }}: {{ item.range }}</span>
        </li>
      }
    </ul>
  </div>
</ng-template>
